<template>
    <div class="story__body video" v-if="!autoplay">
        <div class="text--center">
            <h1 class="title title--dash">
                <span>Discover <br>Campus Resources</span>
            </h1>
            <video-autoplay
                media="Award_Wining_Culture"
                when="campus-resources"
                :custom="true"
            />
        </div>
    </div>
</template>

<script>
import VideoAutoplay from '../Ui/VideoAutoplay'

export default {
    name: 'CampusResourceVideo',
    components: {
        VideoAutoplay
    },
    data() {
        return {
            autoplay: false
        }
    }
}
</script>
